import React, { FC, ReactNode } from 'react';

import styles from './styles.module.css';

type DetailsProps = {
  heading: string;
  content: ReactNode;
};

export const Details: FC<DetailsProps> = ({ heading, content }) => {
  return (
    <div className={styles.wrapper} data-testid="reattribution-details">
      <div className={styles.heading}>{heading}</div>
      {content}
    </div>
  );
};
